import { IStore } from '../../index'

export function getModalLimitIsOpen(state: IStore) {
  return state.userAccount.limitModal.open
}
